import { FaInstagram, FaTwitter, FaYoutube, FaPhoneAlt } from 'react-icons/fa';
import { MdAccessTime, MdLocationOn } from 'react-icons/md';
import { LiaFileDownloadSolid } from 'react-icons/lia';
import colorlogo from 'images/navkar-logo-colored.png';
import logo from 'images/navkar logo.png';
import make from '../../images/Make-in-India.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

export default function Footer() {
    const year = new Date().getFullYear();

    useEffect(() => {
        AOS.init({ duration: 800 });
    }, []);

    return (
        <footer className="bg-[#120B0B]/95 text-white font-Montserrat px-2 sm:px-4 md:px-3 lg:px-20 py-8 overflow-hidden">
            <div className="grid grid-cols-1 max-w-[1200px] mx-auto sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 text-center md:text-left">
                {/* Logo & Description */}
                <div className="flex flex-col items-center md:items-start">
                    <div className="text-3xl font-bold flex items-center gap-2 mb-4">
                        <img src={logo} className="w-36 h-auto max-h-20 object-contain" alt="Navkar Logo" />
                    </div>
                    <p className="text-sm font-Montserrat leading-relaxed mb-4 max-w-sm">
                        Crafted with care, used with confidence. Navkar - the choice of professionals.
                    </p>
                    <div className="flex justify-center md:justify-start space-x-3">
                        <a href="https://www.instagram.com/navkar_laminates_/" className="bg-orange-800 hover:bg-orange-900 p-2 rounded transition"><FaInstagram /></a>
                        <a href="/" className="bg-orange-800 hover:bg-orange-900 p-2 rounded transition"><FaTwitter /></a>
                        <a href="/" className="bg-orange-800 hover:bg-orange-900 p-2 rounded transition"><FaYoutube /></a>
                    </div>
                </div>

                {/* Navigation */}
                <div className="flex flex-col items-center md:items-start">
                    <h3 className="text-lg font-semibold mb-4">Navigation</h3>
                    <ul className="space-y-2 font-Montserrat text-sm">
                        <li><NavLink to="/" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Home</NavLink></li>
                        <li><NavLink to="/products" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Products</NavLink></li>
                        <li><NavLink to="/about" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>About Us</NavLink></li>
                        <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Contact Us</NavLink></li>
                        <li><NavLink to="/policy" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Privacy Policy</NavLink></li>
                         <li><NavLink to="/terms" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Terms & Condition</NavLink></li>
                    </ul>
                </div>

                {/* Quick Links */}
                <div className="flex flex-col font-Montserrat items-center md:items-start">
                    <h3 className="text-lg font-semibold mb-4">Quick Link</h3>
                    <ul className="space-y-2 text-sm">
                        <li><NavLink to="/laminates" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Laminates</NavLink></li>
                        <li><NavLink to="/" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Acrylic</NavLink></li>
                        <li><NavLink to="/" className={({ isActive }) => isActive ? 'text-[#92400e] font-semibold' : 'hover:text-[#92400e]'}>Louvers</NavLink></li>
                    </ul>
                </div>

                {/* Work Hours */}
                <div className="flex flex-col items-center md:items-start">
                    <h3 className="text-lg font-semibold mb-4">Work Hours</h3>
                    <p className="flex items-center text-sm mb-2">
                        <MdAccessTime className="mr-2" size={20} /> 10 AM – 8 PM, Mon - Sat
                    </p>
                    <p className="text-sm font-Montserrat mb-4 max-w-xs text-justify flex items-start gap-2">
                        <MdLocationOn className="mt-1" size={40} />
                        Plot No-8, Navsurgan Industry, Bhatar, Surat - 395001 (Near Navjivan Circle, Near Jalaram Society)
                    </p>
                    <button
                        className="bg-orange-800 font-normal hover:bg-orange-900 text-white py-2 px-4 rounded inline-flex items-center transition"
                        onClick={() => (window.location.href = 'tel:+91xxxxxxxxxx')}
                    >
                        <FaPhoneAlt className="mr-2" />
                        Call Us
                    </button>
                </div>
            </div>

            {/* Catalogue Section */}
            <div className="mt-4 grid grid-cols-1 max-w-[1200px] mx-auto sm:grid-cols-2 gap-6 items-end justify-center">
                <div className="flex flex-col sm:flex-row sm:gap-3 items-center justify-center sm:justify-start" >
                    <img src={make} alt="Make in India" className="w-72 h-auto object-contain" />
                </div>
                <div className="flex justify-end md:mt-4" data-aos="fade-down">
                    <div className="bg-white text-black rounded-lg p-4 flex flex-col sm:flex-row items-center gap-4 w-full max-w-sm">
                        <img src={colorlogo} alt="E-Catalogue" className="w-24 h-auto object-contain" />
                        <div className="flex flex-col items-center text-center bg-white">
                            <h4 className="text-sm font-semibold mb-2">
                                Choose the Right Laminate for Home and Office
                            </h4>
                            <a
                                href="/media/premium-quality-decorative-laminates-02.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-transparent border-black border-2 hover:border-0 text-black px-4 py-2 rounded inline-flex items-center text-sm hover:bg-[#9a3412] hover:text-white transition"
                            >
                                Download E-Catalogue
                                <LiaFileDownloadSolid size={24} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="border-t max-w-[1200px] font-Montserrat mx-auto border-white mt-4 pt-4 px-4 flex flex-col md:flex-row justify-between items-center text-sm text-center md:text-left gap-2">
                <div>
                    © {year} Navkar Laminates. All rights reserved.
                </div>
                <div>
                    Designed and Developed with ❤️ by{' '}
                    <a
                        href="https://efsouls.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white hover:text-blue-300 transition"
                    >
                        EFSOULS
                    </a>
                </div>
            </div>
        </footer>
    );
}
